<template>
  <a-statistic :precision="2" :value="overviewDetails[type] || 0" :prefix="prefix" :suffix="suffix">
      <template #title>
        <div>{{$t('scope.text_298')}}</div>
      </template>
    </a-statistic>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AmountActuallyPaid',
  props: {
    type: String,
  },
  data () {
    return {
      overviewDetails: {},
    }
  },
  computed: {
    ...mapState('app', {
      billAccountInfo: state => state.billAccountInfo,
    }),
    prefix () {
      if (this.billAccountInfo.currency === 'CNY') return ''
      return '$'
    },
    suffix () {
      if (this.billAccountInfo.currency === 'USD') return ''
      return '￥'
    },
  },
  created () {
    this.accountM = new this.$Manager('billing_accounts')
    this.analysisM = new this.$Manager('bill_analysises', 'v1')
    this.fetchData()
  },
  methods: {
    async fetchData () {
      const { data: { data = [] } } = await this.accountM.list()
      const { data: res } = await this.accountM.getSpecific({
        id: data[0].id,
        spec: 'balance',
      })
      this.overviewDetails = res
    },
  },
}
</script>
